import React from 'react';
import * as styles from './style';

const CategoryEmpty = () => (
  <styles.CategoryEmpty>
    <styles.Title>Olá!</styles.Title>
    <styles.Text>Para iniciar seu cadastro de produtos, siga esses passos:</styles.Text>
    <styles.Text>1 Crie suas categorias no campo acima</styles.Text>
    <styles.Text>2 Adicione produtos nas categorias</styles.Text>

    {/* <styles.GuideText>
        Para mais informações <a href="#">acesse o guia completo</a> sobre o
        Portal Único
      </styles.GuideText> */}
  </styles.CategoryEmpty>
);

export default CategoryEmpty;



// WEBPACK FOOTER //
// ./src/screens/Product/CategoryEmpty/index.js